import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ThinkSeedForm from 'components/CreationThinkSeed';
import { ThinkSeedWrapper } from './styles';

class ThinkSeedCreation extends Component {
  componentDidMount() {
    this.setBreadcrumb();
  }

  setBreadcrumb = () => {
    const {
      literals, setBreadcrumb, resetContext,
    } = this.props;

    const breadcrumb = [
      {
        type: 'back',
        onClick: this.handleBackArrow,
      },
      {
        color: '#ffffff',
        text: literals.newTable,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetContext();
  }

  handleBackArrow = () => {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { app: { color1 }, literals, match: { params: { callId } } } = this.props;
    const data = {
      title: literals.defaultTitleForm,
    };

    return (
      <ThinkSeedWrapper color={color1}>
        <ThinkSeedForm callId={callId ? parseInt(callId, 10) : null} data={data} color={color1} fromChats />
      </ThinkSeedWrapper>
    );
  }
}

ThinkSeedCreation.propTypes = {
  app: PropTypes.object.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  resetContext: PropTypes.func.isRequired,
  literals: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default ThinkSeedCreation;



// WEBPACK FOOTER //
// ./src/routes/ThinkSeedCreation/components/ThinkSeedCreation.jsx